import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataSettlementsPage } from '../../../../redux/actions/pages/trans/settlements';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, SETTLEMENTS_GET, PRINT_TRANS_EXTERNAL_LINK, EXCEL_EXPORT_EXTERNAL_LINK, PDF_EXPORT_EXTERNAL_LINK } from '../../../../apis';
import axios from "axios";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { handleChangeDataModalTransDetails } from '../../../../redux/actions/partials/modals/modalTransDetails';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";


const Settlements = () => {

	const dispatch = useDispatch();


	const { token, profile } = useSelector(state => state.login);
    const { settleList } = useSelector(state => state.settlements);

    

    useEffect(() => {
        callApiGetSettlements();
        // eslint-disable-next-line
    }, [Settlements]);


    const [isSearchVisible, setIsSearchVisible] = useState(false);

    const [isHeadingElementsVisible, setIsHeadingElementsVisible] = useState(false);

    const [time, setTime] = useState(null);


    const callApiGetSettlements = (event) => {
        if(event !== undefined)
            event.preventDefault();
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'get',
            url: BASE_SITE + SETTLEMENTS_GET,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token,
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'right'}));
                    break;
                case 'ok':
                    dispatch(handleChangeDataSettlementsPage('settleList', response.data.settlements));
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور. لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));
            dispatch(handleSetBackdropLoading(false));
        });
    };




    return (
		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">




                    <Row>
                        <Col className="col-xs-12">
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">تسویه ها </h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsHeadingElementsVisible(! isHeadingElementsVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isHeadingElementsVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className="icon-minus4"></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                            {/*<li><a onClick={() => setIsSearchVisible(! isSearchVisible)}><i className="icon-search"></i></a></li>*/}
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-body collapse in">


                                    <div className="table-responsive">
                                        <table className="table mb-0 table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{width: '1%'}} >#</th>
                                                    <th>شناسه</th>
                                                    <th>فروشگاه</th>
                                                    <th>شعبه</th>
                                                    <th>صندوق</th>
                                                    <th>مبلغ  (ریال)</th>
                                                    <th>وضعیت</th>
                                                    <th>عملیات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    settleList.map((settle, key) => {
                                                        return(
                                                            <tr>
                                                                <td> {key + 1} </td>
                                                                <td> {settle.unique_id} </td>
                                                                <td> {settle.shop_title} </td>
                                                                <td> {settle.branch_title} </td>
                                                                <td> {settle.operator_name} </td>
                                                                <td> {settle.amount} </td>
                                                                <td> {settle.status_txt} </td>
                                                                <td>

                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav aria-label="Page navigation" className="text-xs-center" style={{marginTop: '3%'}} >

                                    </nav>
                                </div>
                            </div>
                        </Col>
                    </Row>





                </div>
            </div>
        </div>
    );
}

export default Settlements;